// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"e9d76b45","496":"9e946cc7"}[chunkId] + ".chunk.js";
};